import { useEffect, useState } from "react";

type Theme = "light" | "dark";
type Preference = Theme | "system";

const STORAGE_KEY = "sp-theme";

function readStored(): Preference {
  if (typeof localStorage === "undefined") return "system";
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === "light" || v === "dark" || v === "system") return v;
  return "system";
}

// useTheme returns the current theme preference and a setter. The
// preference is one of light / dark / system; "system" removes the
// data-theme attribute so the prefers-color-scheme media query
// decides. Choice persists to localStorage.
export function useTheme(): [Preference, (p: Preference) => void] {
  const [pref, setPref] = useState<Preference>(() => readStored());

  useEffect(() => {
    const root = document.documentElement;
    if (pref === "system") {
      root.removeAttribute("data-theme");
    } else {
      root.setAttribute("data-theme", pref);
    }
    try {
      localStorage.setItem(STORAGE_KEY, pref);
    } catch {
      // SSR, private mode, or storage quota — fail quietly; the
      // in-memory state still works for this session.
    }
  }, [pref]);

  return [pref, setPref];
}
